var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT01Confirm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:done-rounded"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.55 17.5754C9.41667 17.5754 9.29167 17.5544 9.175 17.5124C9.05833 17.4704 8.95 17.3997 8.85 17.3004L4.55 13.0004C4.36667 12.8171 4.279 12.5794 4.287 12.2874C4.295 11.9954 4.391 11.7581 4.575 11.5754C4.75833 11.3921 4.99167 11.3004 5.275 11.3004C5.55833 11.3004 5.79167 11.3921 5.975 11.5754L9.55 15.1504L18.025 6.67539C18.2083 6.49206 18.446 6.40039 18.738 6.40039C19.03 6.40039 19.2673 6.49206 19.45 6.67539C19.6333 6.85872 19.725 7.09639 19.725 7.38839C19.725 7.68039 19.6333 7.91772 19.45 8.10039L10.25 17.3004C10.15 17.4004 10.0417 17.4714 9.925 17.5134C9.80833 17.5554 9.68333 17.5761 9.55 17.5754Z",
    fill: "#0FA44A"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT01Confirm);
export default __webpack_public_path__ + "static/media/t01-confirm.172fb033fb391959e197c61c108b786d.svg";
export { ForwardRef as ReactComponent };